<template>
  <el-card shadow="never">
    <el-row style="margin-bottom: 22px">
      <el-select v-model="queryInfo.storeType" class="form-item" placeholder="请输入捷思区库" filterable style="margin-right: 10px;width: 250px" clearable>
        <el-option v-for="item in storeTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" @click="currentChange(1)" :loading="loading">查询</el-button>
      <el-button type="primary" @click="dialogVisible = true">添加</el-button>
    </el-row>

    <el-table :data="ruleStoreEquivalenceList" border style="width: 100%" stripe>
      <el-table-column align="center" prop="storeTypeName" label="捷思库区"></el-table-column>
      <el-table-column align="center" prop="lenovoStoreName" label="联想库区"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="createUserName" label="创建人"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button @click="deleteRule(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination background layout="total,prev, pager, next" :page-size="pageSize" :total="total" @current-change="currentChange" :current-page.sync="queryInfo.pageNo"></el-pagination>
    </div>
    <el-dialog title="添加优先库规则" :visible.sync="dialogVisible" :close-on-click-modal="false" width="650px" :before-close="handleClose">
      <el-form v-model="formData" label-width="200px">
        <el-form-item label="捷思目标库区：">
          <el-select v-model="formData.storeType" class="form-item" placeholder="捷思库区" filterable style="width: 300px">
            <el-option v-for="item in storeTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联想目标库区：">
          <el-select v-model="formData.lenovoStore" class="form-item" placeholder="联想库区" filterable style="width: 300px">
            <el-option v-for="item in storeTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="addRule">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  name: "RuleStoreEquivalence",
  data() {
    return {
      queryInfo: {
        storeType: '',
        pageNo: 1
      },
      formData: {
        storeType: '',
        lenovoStore: '',
      },
      ruleStoreEquivalenceList: [],
      dialogVisible: false,
      loading: false,
      pageSize: 0,
      total: 0
    }
  },
  computed: {
    storeTypeList() {
      return this.$store.getters.getDictList('storeType') || [];
    },
  },
  created() {
    this.search();
  },
  methods: {
    currentChange(pageNo) {
      this.queryInfo.pageNo = pageNo;
      this.search()
    },
    async search() {
      const {data: res} = await this.$axios.post('ruleStoreEquivalence/queryRule', this.queryInfo);
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }
      this.ruleStoreEquivalenceList = res.data.records;
      this.total = res.data.total;
      this.pageSize = res.data.size;
    },
    deleteRule(row) {
      this.$confirm('确定删除吗？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      }).then(() => {
        this.$axios.post('ruleStoreEquivalence/deleteRule', row.id).then(response => {
          if (response.data.code !== 0) {
            return this.$message.error(response.data.message);
          }
          this.$message.success("删除成功");
          this.search();
        })
      })
    },
    async addRule() {
      if (!this.formData.storeType) {
        return this.$message.error('捷思库区不能为空');
      }
      if (!this.formData.lenovoStore) {
        return this.$message.error('联想库区不能为空');
      }
      const {data: res} = await this.$axios.post('ruleStoreEquivalence/addRule', this.formData);
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }
      this.$message.success("添加成功");
      this.search();
      this.handleClose()
      this.formData.storeType = ''
      this.formData.lenovoStore = ''
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
}
</script>

<style scoped>
.input {
  width: 300px;
  margin-right: 10px;
}
</style>